import * as constants from './constants';
import * as service from './service';
import * as commonConst from '../../common/constants';

export default {
    [constants.CheckEipQuota](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.CheckEipQuota);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [constants.DescribeKeadMinRate](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.DescribeKeadMinRate);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [constants.DescribeKead](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.DescribeKead);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [constants.ValidWhitelist](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.ValidWhitelist);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    }
}
